export const DATA = {
  'HOST': '/'
}